import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

class AuthLoadingScreen extends Component {
  componentDidMount() {
    this.loadApp()
  }
  loadApp = async () => {
    const { auth } = this.props
    const { user } = auth
    if (user) {
      this.props.history.push('/LoggedInHome')
    } else {
      this.props.history.push('/LoggedOutHome')
    }
  }

  render() {
    return <div style={styles.container}>...loading</div>
  }
}

function mapStateToProps({ auth }, props) {
  return {
    auth,
  }
}
export default withRouter(
  connect(
    mapStateToProps,
    null,
  )(AuthLoadingScreen),
)

const styles = {
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
}
